import(/* webpackMode: "eager" */ "/codebuild/output/src2607414978/src/github.com/bitstone/offerz-nextjs/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2607414978/src/github.com/bitstone/offerz-nextjs/node_modules/@mui/material/CircularProgress/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2607414978/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/search/_components/search.tsx");
